import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  Grid
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LanguageIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';
import ColorPalette from '../../../colorpalette/ColorPalette';
import { DataProviderInstance } from '../../../api/DataProvider';

const SendingMethodSelector = ({ sendingMethod, onSendingMethodChange, whatsappConfigured }) => {
  // Handle sending method change
  const handleSendingMethodChange = (event) => {
    onSendingMethodChange(event.target.value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: ColorPalette.white,
        borderRadius: '12px',
        padding: '16px',
        border: `1px solid ${ColorPalette.border}`,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.03)'
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: ColorPalette.blueDark, marginBottom: '12px' }}>
        Método de Envio
      </Typography>
      
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <Paper
          elevation={0}
          onClick={() => whatsappConfigured && handleSendingMethodChange({ target: { value: 'whatsapp_api' } })}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            borderRadius: '8px',
            border: `1px solid ${sendingMethod == 'whatsapp_api' ? ColorPalette.blueMain : ColorPalette.border}`,
            backgroundColor: ColorPalette.white,
            cursor: whatsappConfigured ? 'pointer' : 'not-allowed',
            opacity: whatsappConfigured ? 1 : 0.6,
            transition: 'all 0.2s ease',
            flexGrow: 1,
            '&:hover': {
              backgroundColor: whatsappConfigured && sendingMethod != 'whatsapp_api' ? 'rgba(237, 54, 128, 0.05)' : undefined,
              boxShadow: whatsappConfigured && sendingMethod != 'whatsapp_api' ? '0 2px 8px rgba(0, 0, 0, 0.08)' : undefined
            }
          }}
        >
          <Radio
            checked={sendingMethod == 'whatsapp_api'}
            size="small"
            disabled={!whatsappConfigured}
            sx={{
              padding: '2px',
              marginRight: '8px',
              color: ColorPalette.blueMain,
              '&.Mui-checked': {
                color: ColorPalette.blueMain,
              }
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
              <WhatsAppIcon sx={{ color: '#25D366', fontSize: '1.2rem', marginRight: '8px' }} />
              <Typography variant="body1" sx={{ fontWeight: sendingMethod == 'whatsapp_api' ? 600 : 500, color: ColorPalette.textDark }}>
                WhatsApp
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ color: ColorPalette.textMedium }}>
              {whatsappConfigured ? 'Envio direto via API do WhatsApp' : 'Configuração do WhatsApp necessária'}
            </Typography>
            {!whatsappConfigured && (
              <Typography variant="caption" sx={{ color: ColorPalette.error, fontSize: '0.7rem', mt: 0.5 }}>
                Configure o WhatsApp na seção de configurações para ativar esta automação
              </Typography>
            )}
          </Box>
        </Paper>
        
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            borderRadius: '8px',
            border: `2px solid ${ColorPalette.border}`,
            backgroundColor: ColorPalette.white,
            cursor: 'not-allowed',
            opacity: 0.6,
            transition: 'all 0.2s ease',
            flexGrow: 1
          }}
        >
          <Radio
            checked={false}
            size="small"
            disabled={true}
            sx={{
              padding: '2px',
              marginRight: '8px',
              color: ColorPalette.secondary,
              '&.Mui-checked': {
                color: ColorPalette.secondary,
              }
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
              <EmailIcon sx={{ color: ColorPalette.blueMain, fontSize: '1.2rem', marginRight: '8px' }} />
              <Typography variant="body1" sx={{ fontWeight: 500, color: ColorPalette.textDark }}>
                Email
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ color: ColorPalette.textMedium }}>
              Envio via email (indisponível no momento)
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Paper>
  );
};

export default SendingMethodSelector;